import * as DG from 'datagrok-api/dg';
import wu from 'wu';
import { getMolColName, hexToPercentRgb } from './utils';
import { HelmTypes, PolymerTypes } from '../helm/consts';
export async function seqToMolFileWorker(seqCol, monomersDict, alphabet, polymerType, monomerLib, seqHelper, rdKitModule, rolesList, chainStartsList) {
    const srcColLength = seqCol.length;
    const df = seqCol.dataFrame;
    const threadCount = Math.max(navigator.hardwareConcurrency - 2, 1);
    const workers = new Array(threadCount).fill(null)
        .map(() => new Worker(new URL('./seq-to-molfile-worker', import.meta.url)));
    const chunkSize = srcColLength / threadCount;
    const promises = new Array(threadCount);
    const seqSH = seqHelper.getSeqHandler(seqCol);
    const biotype = polymerType == PolymerTypes.RNA ? HelmTypes.NUCLEOTIDE : HelmTypes.AA;
    const seqList = wu.count(0).take(seqCol.length).map((rowIdx) => {
        const seqSS = seqSH.getSplitted(rowIdx);
        return wu.count(0).take(seqSS.length)
            .map((posIdx) => {
            return { position: posIdx, symbol: seqSS.getCanonical(posIdx), biotype: biotype };
        })
            .toArray();
    }).toArray();
    for (let i = 0; i < threadCount; i++) {
        const worker = workers[i];
        const start = Math.floor(i * chunkSize);
        const end = (i === threadCount - 1) ? srcColLength : Math.floor((i + 1) * chunkSize);
        promises[i] = new Promise((resolve) => {
            worker.onmessage = (res) => {
                resolve(res.data);
            };
        });
        worker.postMessage({ seqList, rolesList, chainStartsList, monomersDict, alphabet, polymerType, start, end });
    }
    const molList = [];
    const warnings = [];
    await Promise.all(promises).then((resArray) => {
        for (const resItem of resArray) {
            molList.push(...resItem.molfiles);
            warnings.push(...resItem.warnings);
        }
    });
    //const molHlList = molList.map((item: MolfileWithMap) => getMolHighlight(item.monomers.values(), monomerLib));
    setTimeout(() => {
        workers.forEach((worker) => {
            worker.terminate();
        });
    }, 0);
    const molColName = getMolColName(df, seqCol.name);
    const molCol = DG.Column.fromType(DG.COLUMN_TYPE.STRING, molColName, seqCol.length)
        .init((rowIdx) => molList[rowIdx]?.molfile);
    molCol.semType = DG.SEMTYPE.MOLECULE;
    molCol.meta.units = DG.UNITS.Molecule.MOLBLOCK;
    molCol.setTag(".sequence-src-col" /* ChemTags.SEQUENCE_SRC_COL */, seqCol.name);
    return { molCol: molCol, warnings: warnings };
}
export function getMolHighlight(monomerMaps, monomerLib) {
    const hlAtoms = {};
    const hlBonds = {};
    for (const monomerMapValue of monomerMaps) {
        const wem = monomerLib.getWebEditorMonomer(monomerMapValue.biotype, monomerMapValue.symbol);
        const mColorStr = wem.backgroundcolor;
        // eslint-disable-next-line deprecation/deprecation
        const mColorA = hexToPercentRgb(mColorStr ?? DG.Color.toRgb(DG.Color.mouseOverRows)) ?? [1.0, 0.0, 0.0, 0.7];
        for (const mAtom of monomerMapValue.atoms)
            hlAtoms[mAtom] = mColorA;
        for (const mBond of monomerMapValue.bonds)
            hlBonds[mBond] = mColorA;
    }
    const resSubstruct = {
        atoms: Object.keys(hlAtoms).map((k) => parseInt(k)),
        bonds: Object.keys(hlBonds).map((k) => parseInt(k)),
        highlightAtomColors: hlAtoms,
        highlightBondColors: hlBonds,
    };
    return resSubstruct;
}
//# sourceMappingURL=seq-to-molfile.js.map